import { PageObject } from "../../pages/admin/Translations";

export const notificationReducer = (state:NotificationObject | {}, action:any) => {
    switch (action.type) {
        case 'SET_NOTIFICATION':
            state = action.payload;
            return state;
        default:
            return state || {};
    }
}

export const languageReducer = (state:"N" | "E" | "F", action:any) => {
    switch(action.type) {
        case 'SET_LANGUAGE':
            state = action.payload;
            return state;
        default:
            return state || "N";
    }
}

export const contentReducer = (state:PageObject, action:any) => {
    switch(action.type) {
        case 'SET_CONTENT':
            state = action.payload;
            return state;
        default:
            return state || {}
    }
}